import React from 'react'
import { useParams } from 'react-router'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import { Button, Container } from 'gu-ui-kit'
import styles from 'modules/LocalPay/LocalPay.module.scss'

const LocalPay = () => {
  const { hash } = useParams()
  const pathGen = useGeneratePathI18n()

  return (
    <Container className={styles['container']}>
      <h1>LocalPay</h1>
      <p>Simulate success payment</p>
      <p>Just click on button</p>
      {hash && <p>Payment ticket hash: {hash}</p>}

      <Button
        variant={'primary'}
        component={Link}
        to={pathGen(ROUTES.BILLING_PAYMENT_RESULT, { type: 'success' })}
      >
        Go back
      </Button>
    </Container>
  )
}

export default LocalPay
